import React from 'react';

import { componentWithFG } from '@atlaskit/platform-feature-flags-react';

import type { GlobalMoreMenuProps } from '../types';

import { MoreMenuPopup } from './more-menu-popup';
import { getHiddenItems } from './utils/get-hidden-items';

export const GlobalMoreMenu = componentWithFG(
	'navx-1410-a11y-fixes-customize-modal',
	GlobalMoreMenuNEW,
	GlobalMoreMenuOLD,
);
export default GlobalMoreMenu; // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering

function GlobalMoreMenuNEW({
	productItemsData,
	appItemsData = [],
	menuItemComponent,
	customizeSidebarMenuItem,
	moreMenuItemLabel,
	peekingMenuIds = [],
	onClickMoreMenuTrigger,
	testId,
	triggerRef,
	triggerVisualContentRef,
	dropIndicator,
}: GlobalMoreMenuProps) {
	const { hiddenProductItemsData, hiddenAppItemsData, shouldShowMoreMenu } = getHiddenItems(
		productItemsData,
		appItemsData,
		peekingMenuIds,
	);

	return (
		<MoreMenuPopup
			productItemsData={hiddenProductItemsData}
			appItemsData={hiddenAppItemsData}
			moreMenuItemComponent={menuItemComponent}
			customizeSidebarMenuItem={customizeSidebarMenuItem}
			moreMenuItemLabel={moreMenuItemLabel}
			onClickMoreMenuTrigger={onClickMoreMenuTrigger}
			showMoreMenu={shouldShowMoreMenu}
			testId={testId}
			triggerRef={triggerRef}
			triggerVisualContentRef={triggerVisualContentRef}
			dropIndicator={dropIndicator}
		/>
	);
}

function GlobalMoreMenuOLD({
	productItemsData,
	appItemsData = [],
	menuItemComponent,
	customizeSidebarMenuItem,
	moreMenuItemLabel,
	peekingMenuIds = [],
	onClickMoreMenuTrigger,
	testId,
	triggerRef,
	triggerVisualContentRef,
	dropIndicator,
}: GlobalMoreMenuProps) {
	const { hiddenProductItemsData, hiddenAppItemsData, shouldShowMoreMenu } = getHiddenItems(
		productItemsData,
		appItemsData,
		peekingMenuIds,
	);

	if (!shouldShowMoreMenu) {
		return <>{customizeSidebarMenuItem}</>;
	}

	return (
		<MoreMenuPopup
			productItemsData={hiddenProductItemsData}
			appItemsData={hiddenAppItemsData}
			moreMenuItemComponent={menuItemComponent}
			customizeSidebarMenuItem={customizeSidebarMenuItem}
			moreMenuItemLabel={moreMenuItemLabel}
			onClickMoreMenuTrigger={onClickMoreMenuTrigger}
			testId={testId}
			triggerRef={triggerRef}
			triggerVisualContentRef={triggerVisualContentRef}
			dropIndicator={dropIndicator}
		/>
	);
}
